import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve an image_url stored in DB.
 * - If it's a full absolute URL (starts with http:// or https://) return as-is.
 * - If it's a relative path (e.g. "/api/gallery/image/abc") prepend BACKEND_URL
 *   so it works both on preview and production regardless of where the frontend is served.
 * - SPECIAL CASE: if the URL points to /api/gallery/image/... on the WRONG host
 *   (internal cluster domain because of legacy uploads), we force-rewrite it to
 *   the correct BACKEND_URL. This makes the frontend self-healing without a DB migration.
 * - Empty / null → empty string (caller should guard).
 */
export function resolveImageUrl(url) {
  if (!url) return "";
  // Force-fix legacy absolute URLs that point to internal cluster hosts
  const galleryPathMatch = url.match(/\/api\/gallery\/image\/[a-f0-9]+/i);
  if (galleryPathMatch) {
    return `${BACKEND_URL}${galleryPathMatch[0]}`;
  }
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Invalid/expired admin session: drop the token and go back to the login page
export function handleAdminAuthError(error) {
  if (error?.response?.status === 401 && localStorage.getItem("fp_admin_token")) {
    localStorage.removeItem("fp_admin_token");
    window.location.assign("/admin/login?sessione=scaduta");
  }
  return Promise.reject(error);
}

export const adminApi = () => {
  const token = localStorage.getItem("fp_admin_token");
  const client = axios.create({
    baseURL: API,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  client.interceptors.response.use(undefined, handleAdminAuthError);
  return client;
};

export const LOGO_URL = "/logo.png";

export const HERO_BG_URL = "/images/hero-bg.jpg";

export const PREMIUM_BG_URL = "/images/premium-bg.jpg";

export const SOCCER_BALL_URL = "/images/soccer-ball.jpg";

export const STADIUM_URL = "/images/stadium.jpg";

